import angular from 'angular';
import { UserNotificationsMenuItemBridge } from './UserNotificationsMenuItemBridge';
import { UserNotificationsPanelBridge } from './UserNotificationsPanelBridge';

angular
  .module('flowingly.user.notifications', ['ngAnimate'])
  .component('userNotifications', UserNotificationsMenuItemBridge)
  .component('userNotificationsPanel', UserNotificationsPanelBridge);
